import Experience from "./Experience/Experience.js";

export default class Cyber60 {
    static instance = null;

    static create(el) {
        if(!Cyber60.instance) {
            Cyber60.instance = new Cyber60(el);
        }
        return Cyber60.instance;
    }

    static destroy() {
        if(Cyber60.instance) {
            Cyber60.instance.beforeDestroy();
            Cyber60.instance = null;
        }
    }

    constructor(parent) {
        this.experience = new Experience(parent);
    }


    beforeDestroy() {
        this.experience.destroy();
    }
}
